import { __decorate, __metadata } from "tslib";
import { injectable, } from '@patsnap/tahiti-core/shared/inversify';
import { ROOT_FOLDER_ID } from '../constants';
let FolderListApiDtoImpl = class FolderListApiDtoImpl {
    constructor() { }
    transformListToTree(list) {
        const itemMap = {};
        list.forEach(item => {
            itemMap[item.folder_id] = {
                ...item,
                children: [],
            };
        });
        const tree = [];
        list.forEach(item => {
            const node = itemMap[item.folder_id];
            if (item.parent_id === ROOT_FOLDER_ID) {
                tree.push(node);
            }
            else {
                const parentNode = itemMap[item.parent_id];
                if (parentNode) {
                    parentNode.children.push(node);
                }
            }
        });
        return tree;
    }
};
FolderListApiDtoImpl = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], FolderListApiDtoImpl);
export { FolderListApiDtoImpl };
